import { createActions, createReducer } from 'reduxsauce'

export const { Types: VouchersTypes, Creators: VouchersActions } = createActions({
    getVouchers: [],
    getVouchersSuccess: ['vouchers'],
    getVouchersFailure: ['getVouchersError'],

    getVouchersDetails: [],
    getVouchersDetailsSuccess: ['vouchersDetails'],
    getVouchersDetailsFailure: ['getVouchersDetailsError'],

    uploadVouchers: ['body', 'callback'],
    uploadVouchersSuccess: [],
    uploadVouchersFailure: [],

    archiveVouchers: ['body', 'callback'],
    archiveVouchersSuccess: [],
    archiveVouchersFailure: [],

    deleteVouchers: ['body', 'callback'],
    deleteVouchersSuccess: [],
    deleteVouchersFailure: [],

    updateVoucherCode: ['body', 'callback'],
    updateVoucherCodeSuccess: [],
    updateVoucherCodeFailure: ['updateVoucherCodeError'],

    setSelectedVouchers: ['selectedVouchers'],
    setVoucherColumnsSort: ['column'],
})

const INITIAL_STATE = {
    vouchers: [],
    getVouchersLoading: false,
    getVouchersError: null,

    vouchersDetails: [],
    getVouchersDetailsLoading: false,
    getVouchersDetailsError: null,

    uploadVouchersLoading: false,
    uploadVouchersError: null,

    archiveVouchersLoading: false,
    archiveVouchersError: null,

    deleteVouchersLoading: false,
    deleteVouchersError: null,

    updateVoucherCodeLoading: false,
    updateVoucherCodeError: null,

    currentPage: 0,
    selectedVouchers: [],
    voucherColumnSortBy: [],
}

export const reducer = createReducer(INITIAL_STATE, {
    // getVouchers
    [VouchersTypes.GET_VOUCHERS]: state => ({ ...state, getVouchersLoading: true }),
    [VouchersTypes.GET_VOUCHERS_SUCCESS]: (state, { vouchers }) => ({ ...state, getVouchersLoading: false, vouchers, getVouchersError: null }),
    [VouchersTypes.GET_VOUCHERS_FAILURE]: (state, { getVouchersError }) => ({ ...state, getVouchersLoading: false, vouchers: [], getVouchersError }),

    // vouchersDetails
    [VouchersTypes.GET_VOUCHERS_DETAILS]: state => ({ ...state, getVouchersDetailsLoading: true }),
    [VouchersTypes.GET_VOUCHERS_DETAILS_SUCCESS]: (state, { vouchersDetails }) => ({
        ...state,
        getVouchersDetailsLoading: false,
        vouchersDetails: [vouchersDetails],
        getVouchersDetailsError: null,
    }),
    [VouchersTypes.GET_VOUCHERS_DETAILS_FAILURE]: (state, { getVouchersDetailsError }) => ({
        ...state,
        getVouchersDetailsLoading: false,
        vouchersDetails: [],
        getVouchersDetailsError,
    }),

    // uploadVouchers
    [VouchersTypes.UPLOAD_VOUCHERS]: state => ({ ...state, uploadVouchersLoading: true }),
    [VouchersTypes.UPLOAD_VOUCHERS_SUCCESS]: state => ({ ...state, uploadVouchersLoading: false, uploadVouchersError: null }),
    [VouchersTypes.UPLOAD_VOUCHERS_FAILURE]: (state, { uploadVouchersError }) => ({ ...state, uploadVouchersLoading: false, uploadVouchersError }),

    // archiveVouchers
    [VouchersTypes.ARCHIVE_VOUCHERS]: state => ({ ...state, archiveVouchersLoading: true }),
    [VouchersTypes.ARCHIVE_VOUCHERS_SUCCESS]: state => ({ ...state, archiveVouchersLoading: false, archiveVouchersError: null }),
    [VouchersTypes.ARCHIVE_VOUCHERS_FAILURE]: (state, { archiveVouchersError }) => ({
        ...state,
        archiveVouchersLoading: false,
        archiveVouchersError,
    }),

    // deleteVouchers
    [VouchersTypes.ARCHIVE_VOUCHERS]: state => ({ ...state, deleteVouchersLoading: true }),
    [VouchersTypes.DELETE_VOUCHERS_SUCCESS]: state => ({ ...state, deleteVouchersLoading: false, deleteVouchersError: null }),
    [VouchersTypes.DELETE_VOUCHERS_FAILURE]: (state, { deleteVouchersError }) => ({
        ...state,
        deleteVouchersLoading: false,
        deleteVouchersError,
    }),

    // updateVoucherCode
    [VouchersTypes.UPDATE_VOUCHER_CODE]: state => ({ ...state, updateVoucherCodeLoading: true }),
    [VouchersTypes.UPDATE_VOUCHER_CODE_SUCCESS]: state => ({ ...state, updateVoucherCodeLoading: false, updateVoucherCodeError: null }),
    [VouchersTypes.UPDATE_VOUCHER_CODE_FAILURE]: (state, { updateVoucherCodeError }) => ({
        ...state,
        updateVoucherCodeLoading: false,
        updateVoucherCodeError,
    }),

    // setSelectedVouchers
    [VouchersTypes.SET_SELECTED_VOUCHERS]: (state, { selectedVouchers }) => ({ ...state, selectedVouchers }),
    // setVoucherColumnsSort
    [VouchersTypes.SET_VOUCHER_COLUMNS_SORT]: (state, { column }) => ({ ...state, voucherColumnSortBy: column }),
})
